<script setup lang="ts">
import { useCookies } from '@vueuse/integrations/useCookies';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const router = useRouter();
const route = useRoute();
const cookies = useCookies(['auth-token', 'refresh-token']);

// Handle OAuth callback
onMounted(() => {
  // Get tokens from URL parameters
  const token = route.query.token as string;
  const refreshToken = route.query.refreshToken as string;

  if (token && refreshToken) {
    // Save tokens to cookies
    cookies.set('auth-token', token);
    cookies.set('refresh-token', refreshToken);

    // Use redirect URL if available; otherwise, redirect to dashboard
    const redirectUrl = localStorage.getItem('auth_redirect_url') || '/dashboard';
    localStorage.removeItem('auth_redirect_url'); // Clear redirect URL

    // Redirect to protected page
    router.push(redirectUrl);
  } else {
    // If no token is found, redirect to login page with error message
    router.push('/auth/sign-in?error=auth_failed');
  }
});
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-[100dvh]">
    <div class="text-center">
      <h2 class="text-2xl font-bold mb-4">Authenticating...</h2>
      <p class="text-gray-600">Please wait, processing your login information</p>

      <!-- Loading animation -->
      <div class="mt-8">
        <div
          class="animate-spin rounded-full h-12 w-12 border-4 border-primary border-t-transparent mx-auto"
        />
      </div>
    </div>
  </div>
</template>
